var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileChartLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-chart-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6 7.5H13.4V16.5H11.6V7.5ZM15.2 11.1H17V16.5H15.2V11.1ZM7.99999 12.9H9.79999V16.5H7.99999V12.9ZM15.2 4.8H6.19999V19.2H18.8V8.4H15.2V4.8ZM4.39999 3.8928C4.39999 3.3996 4.80229 3 5.29909 3H16.1L20.6 7.5V20.0937C20.6008 20.2119 20.5784 20.3291 20.5339 20.4386C20.4894 20.5481 20.4238 20.6478 20.3409 20.7319C20.2579 20.8161 20.1591 20.8831 20.0502 20.9291C19.9414 20.9751 19.8245 20.9992 19.7063 21H5.29369C5.05733 20.9984 4.83111 20.9038 4.66389 20.7367C4.49667 20.5697 4.40188 20.3436 4.39999 20.1072V3.8928Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileChartLine);
export default __webpack_public_path__ + "static/media/file-chart-line.927dff464914334356ec58f59954e34b.svg";
export { ForwardRef as ReactComponent };